// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Surface-module__root--VPkjk {
  box-sizing: border-box;
}

.Surface-module__variant-filled--gMlac {
  border-radius: 12px;
  background-color: var(--chaek-color-surface-subtle);
}

.Surface-module__variant-outlined--__X1R {
  border: 1px solid var(--chaek-color-border-divider);
  border-radius: 22px;
  background-color: var(--chaek-color-surface-canvas);
}

.Surface-module__spacing-small--YCi8b {
  padding: 12px 14px;
}

.Surface-module__spacing-medium--Qoi_X {
  padding: 18px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Surface/Surface.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,mDAAmD;EACnD,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".root {\n  box-sizing: border-box;\n}\n\n.variant-filled {\n  border-radius: 12px;\n  background-color: var(--chaek-color-surface-subtle);\n}\n\n.variant-outlined {\n  border: 1px solid var(--chaek-color-border-divider);\n  border-radius: 22px;\n  background-color: var(--chaek-color-surface-canvas);\n}\n\n.spacing-small {\n  padding: 12px 14px;\n}\n\n.spacing-medium {\n  padding: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Surface-module__root--VPkjk`,
	"variant-filled": `Surface-module__variant-filled--gMlac`,
	"variant-outlined": `Surface-module__variant-outlined--__X1R`,
	"spacing-small": `Surface-module__spacing-small--YCi8b`,
	"spacing-medium": `Surface-module__spacing-medium--Qoi_X`
};
export default ___CSS_LOADER_EXPORT___;
